
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import ProcessSection from './components/ProcessSection';
import SocialProof from './components/SocialProof';
import WhyLisa from './components/WhyLisa';
import PricingSection from './components/PricingSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F9F8F6]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <Hero />
      <ProblemSection />
      <ProcessSection />
      <WhyLisa />
      <SocialProof />
      <PricingSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
